module.exports = __webpack_public_path__ + "ff219d965751c224d5a2617289bf8f44.png";